var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{staticClass:"pz__drag-handle d-inline-block",class:{ 'drag--disabled': !_vm.draggable }},[_c('feather-icon',{attrs:{"icon":"MenuIcon","size":"16"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }